import { authorityMutation } from '../mutations/authority'
import { authorityAction } from '../actions/authority'

export const authority = {
  state: {
    isLogining: false,
    logged: false,
    loginSuccess: false,
    loginFailure: false,
    userInfo: {}
  },
  mutations: authorityMutation,
  actions: authorityAction
}



// WEBPACK FOOTER //
// ./src/store/modules/authority.js